export class FleetTrackerConfig {
    apiKey: string;
    // places?: boolean;
    // drawing?: boolean;
    geography?: boolean;
    // visualization?: boolean;
    apiKeyLoader?: () => Promise<string>;
}
